















































































import { Vue, Component } from "vue-property-decorator";
//引入vuex中的TagsViewModule模块
import { TagsViewModule } from "../../store/modules/tagsView";
//引入vuex中的user模块
import { UserModule } from "../../store/modules/user";
//引入vuex中的app模块
import { AppModule } from "../../store/modules/app";
//引入vuex中的permission模块
import { PermissionModule } from "../../store/modules/permission";
// 引入密码校验
import { ruleNormal, rulePattern } from "../../utils/common";
@Component({
  name: "layout",
  components: {
    Hamburger: () => import("@/components/Hamburger/index.vue"),
    sideMenu: () => import("./module/sideMenu.vue")
  }
})
export default class layout extends Vue {
  // 是否IE浏览器
  private isIEBrowser: boolean = false;
  private ifResetPwd: boolean = false;
  private systemTitle: string = "";
  private old2NewPwd: object = {
    oldPwd: "",
    newPwd: "",
    checkPwd: ""
  };
  private userName = UserModule.userName;

  get key() {
    return this.$route.fullPath;
  }

  get sidebar() {
    return AppModule.sidebar;
  }

  get isCollapse() {
    return !this.sidebar.opened;
  }

  get cachedViews() {
    return TagsViewModule.cachedViews;
  }

  get permission_routes() {
    return PermissionModule.routes.filter(item => {
      if (item.children) return item;
      // return item
    });
  }

  //切换侧边菜单处理
  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  // 清空输入框数据
  private clearInputData(){
    (this.old2NewPwd as any).newPwd = '';
    (this.old2NewPwd as any).oldPwd = '';
    (this.old2NewPwd as any).checkPwd = '';
  }

  // side-menu 点击则自动取消修改密码
  private cancelReset(data){
    this.ifResetPwd = data;
    this.clearInputData()
  }

  private noReset(){
    this.ifResetPwd = false;
    this.clearInputData()
  }

  mounted(){
    this.systemTitle = window.config.systemTitle;
    this.isIEBrowser = !!(window as any).ActiveXObject || "ActiveXObject" in window;
  }
  // 校验两次密码一致
  private validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== (this.old2NewPwd as any).newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

  // 修改密码页面格式校验
  private ruleForm: object = {
    oldPwd: [
      ruleNormal("请输入用户密码")
    ],
    newPwd: [
      ruleNormal("请输入新的用户密码"),
      rulePattern(
        /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/,
        "密码长度8-30字符，必须包含字母、数字、特称字符"
      )
    ],
    checkPwd: [
      ruleNormal("请再次输入密码"),
      { validator: this.validatePass2, trigger: 'blur' }
    ],
  }

  // 提交修改密码
  private submitForm(formName){
    (this.$refs[formName] as HTMLFormElement).validate(async (valid) =>{
      if(valid){
        let isTeacherLogin = sessionStorage.getItem("isTeacherLogin")
        let params = {
          type:isTeacherLogin? 'teacher' : 'school',
          value:{
          newPassword:(this.old2NewPwd as any).newPwd,
          oldPassword:(this.old2NewPwd as any).oldPwd
          }
        }
          let type = isTeacherLogin? "teacher" : "school"
          let res = await UserModule.ResetPwd(params)
          this.clearInputData()
        if(res){
          this.ifResetPwd = false;
          this.$message.success("修改成功");
        }
      }
    })
  }
  // 重置输入内容
  // private resetForm(formName) {
  //       (this.$refs[formName] as HTMLFormElement).resetFields();
  //     }




  //登出处理
  private async logoutHandle() {
    try {
      const path = sessionStorage.getItem("isSchoolLogin") ? '/school' : '/teacher';

      //调登录的接口，获取token
      await UserModule.LogOut();
      this.$router.push(path);
    } catch (error) {
      // this.$message(error || "退出失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 修改密码
  private async resetPwd(){
    this.ifResetPwd = true;
  }
}

